import api from "../api";
import { db } from "../firebase";
import { collection, getDocs, doc, setDoc, updateDoc, deleteDoc, query, orderBy, addDoc } from "firebase/firestore";

export const getAboutUs = async () => {
  try {
    const response = await api.get("/aboutus", {
      params: {
        pageNumber: 1,
        pageSize: 1000,
      },
    });
    if (response?.data?.items) {
      response.data.items.forEach((item: any) => {
        if (item?.translations) {
          item.translations.forEach((translation: any) => {
            if (translation.languageCode === "ar" && translation.content) {
              translation.content = translation.content
                .replace(/(?:TowHelp\.?\s*)?هو تطبيق جوال مبتكر يعيد تعريف خدمات المساعدة على الطريق(?:\.?\s*TowHelp\.?)?/i, "TowHelp هو تطبيق جوال مبتكر يعيد تعريف خدمات المساعدة على الطريق.")
                .replace("يتيح للسائقين TowHelp الاتصال", "يتيح TowHelp للسائقين الاتصال")
                .replace("بما يساعدهم على توسيع TowHelp السائقين بالمزوّدين أعمالهم وتنميتها.", "بما يساعدهم على توسيع أعمالهم وتنميتها.")
                .replace("يربط TowHelp بكفاءة،", "يربط TowHelp السائقين بالمزوّدين بكفاءة،")
                .replace("يتيح للسائقين الاتصال بمزوّدي خدمات موثوقين في الوقت الفعلي", "يتيح للسائقين الوصول إلى مقدمي خدمات موثوقين بشكل فوري وعلى مدار الساعة.")
                .replace("للتعامل مع المواقف الطارئة مثل سحب السيارات، وانفجار الإطارات، ونفاد البطارية، والإغلاق، وتوصيل الوقود.", "للتعامل مع المواقف الطارئة مثل خدمات الونش، وإصلاح الإطارات، وخدمة وصلة البطارية، وتوصيل الوقود، وغيرها من خدمات المساعدة على الطريق.")
                .replace("للتعامل مع المواقف الطارئة مثل سحب السيارات، وانفجار الإطارات، ونفاد البطارية، والإغلاق، وتوصيل الوقود", "للتعامل مع المواقف الطارئة مثل خدمات الونش، وإصلاح الإطارات، وخدمة وصلة البطارية، وتوصيل الوقود، وغيرها من خدمات المساعدة على الطريق.");
            }
          });
        }
      });
    }
    return response.data;
  } catch (error) {
    console.error("Failed to fetch About Us data:", error);
    throw error;
  }
};

export const saveContactUs = async (data: any) => {
  try {
    const response = await api.put("/contactus", data, {
      //json body
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to save Contact Us data:", error);
    throw error;
  }
};
export const getContactUs = async () => {
  try {
    const response = await api.get("/contactus", {
      params: {
        pageNumber: 1,
        pageSize: 1000,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch Contact Us data:", error);
    throw error;
  }
};

export const getCrew = async () => {
  try {
    const response = await api.get("/crew", {
      params: {
        pageNumber: 1,
        pageSize: 1000,
      },
    });
    if (response?.data?.items) {
      response.data.items.forEach((item: any) => {
        const hasRamy = item?.translations?.some(
          (t: any) => t.languageCode === "en" && t.fullName === "Ramy Omar"
        );
        if (hasRamy) {
          item.translations.forEach((t: any) => {
            if (t.languageCode === "ar") {
              t.bio = "مسؤول عن وضع الرؤية والاستراتيجية وقيادة نمو الشركة\n يمثل توهيلب أمام المستثمرين والشركاء ويقود التوسع لضمان تقديم خدمات مبتكرة وموثوقة للمساعدة على الطريق";
            }
          });
        }
        const hasFatma = item?.translations?.some(
          (t: any) => t.languageCode === "en" && t.fullName === "Fatma Moneim"
        );
        if (hasFatma) {
          item.translations.forEach((t: any) => {
            if (t.languageCode === "ar") {
              t.bio = "يقود استراتيجيات التسويق في توهيلب لزيادة عدد العملاء ومقدمي الخدمة، يبني الوعي بالعلامة التجارية،\nيدير الحملات الرقمية، ويعمل على اكتساب واحتفاظ العملاء من خلال أفكار مبتكرة وتحليل الأداء";
            }
          });
        }
        const hasAyman = item?.translations?.some(
          (t: any) => t.languageCode === "en" && t.fullName === "Ayman Youssef"
        );
        if (hasAyman) {
          item.translations.forEach((t: any) => {
            if (t.languageCode === "ar") {
              t.bio = "يشرف على كل الجوانب القانونية في توهيلب،\n يضمن الالتزام بالقوانين واللوائح، يصيغ ويدقق العقود والسياسات، ويتابع القضايا والنزاعات لحماية حقوق الشركة ومصالحها";
            }
          });
        }
        const hasRana = item?.translations?.some(
          (t: any) => t.languageCode === "en" && t.fullName === "Rana Amr"
        );
        if (hasRana) {
          item.translations.forEach((t: any) => {
            if (t.languageCode === "ar") {
              t.bio = "مدير المشروع في توهيلب ومسؤول عن تخطيط وتنظيم وتنفيذ المشاريع لضمان تسليمها في الوقت المحدد وبجودة عالية. يدير فرق العمل المختلفة ويتابع التقدم لضمان تحقيق أهداف الشركة.";
            }
          });
        }
      });
    }
    return response.data;
  } catch (error) {
    console.error("Failed to fetch Crew data:", error);
    throw error;
  }
};

export const getMissionVesion = async () => {
  try {
    const response = await api.get("/missionvision", {
      params: {
        pageNumber: 1,
        pageSize: 1000,
      },
    });
    if (response?.data?.items) {
      response.data.items.forEach((item: any) => {
        if (item?.translations) {
          item.translations.forEach((translation: any) => {
            if (translation.languageCode === "ar" && translation.vision) {
              translation.vision = translation.vision
                .replace("أن نكون المنصة الرقمية الرائدة لخدمات المساعدة على الطريق، الموثوق لكل سائق", "أن نكون المنصة الرقمية الرائدة والأكثر موثوقية لخدمات المساعدة على الطريق، والخيار الأول لكل سائق في مصر.")
                .replace("أن نكون المنصة الرقمية الرائدة لخدمات المساعدة على الطريق، الموثوق لكل سائق.", "أن نكون المنصة الرقمية الرائدة والأكثر موثوقية لخدمات المساعدة على الطريق، والخيار الأول لكل سائق في مصر.");
            }
          });
        }
      });
    }
    return response.data;
  } catch (error) {
    console.error("Failed to fetch Crew data:", error);
    throw error;
  }
};

export const getJoinCrew = async () => {
  try {
    const response = await api.get("/joincrew", {
      params: {
        pageNumber: 1,
        pageSize: 1000,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch Services data:", error);
    throw error;
  }
};

export const getRequests = async () => {
  try {
    const response = await api.get("/joincrew", {
      params: {
        pageNumber: 1,
        pageSize: 1000,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch requests:", error);
    throw error;
  }
};

export const deleteRequest = async (id: number) => {
  try {
    const response = await api.delete(`/joincrew/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to delete request:", error);
    throw error;
  }
};

export const updateRequest = async ({
  id,
  status,
}: {
  id: number;
  status: number;
}) => {
  try {
    const response = await api.put("/joincrew", {
      id,
      status,
    });
    return response.data;
  } catch (error) {
    console.error("Failed to update request status:", error);
    throw error;
  }
};

export const getServices = async () => {
  try {
    const response = await api.get("/service", {
      params: {
        pageNumber: 1,
        pageSize: 1000,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch Services data:", error);
    throw error;
  }
};

export const joinCrew = async (formData: any) => {
  try {
    const response = await api.post("/joincrew", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to submit join crew data:", error);
    throw error;
  }
};

export const getBanners = async () => {
  try {
    const response = await api.get("/banner", {
      params: {
        pageNumber: 1,
        pageSize: 1000,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch banners:", error);
    throw error;
  }
};

export const getBrands = async () => {
  try {
    const response = await api.get("/brand-profiles");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch brands:", error);
    throw error;
  }
};

export const postBrand = async (data: any) => {
  const response = await api.post(`/brand-profiles`, data);
  return response.data;
};

export const editBrand = async (id: any, data: any) => {
  const response = await api.put(`/brand-profiles/${id}`, data);
  return response.data;
};

// Subdomain-shared cookie storage helper functions
const getCookieDomain = () => {
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return ".localhost";
  }
  const parts = hostname.split(".");
  if (parts.length >= 2) {
    return "." + parts.slice(-2).join(".");
  }
  return hostname;
};

const setCookie = (name: string, value: string, days: number) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const domain = getCookieDomain();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; domain=${domain}`;
};

const getCookie = (name: string) => {
  return document.cookie.split("; ").reduce((r, v) => {
    const parts = v.split("=");
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, "");
};

const getSharedBookings = () => {
  const cookieData = getCookie("shared_bookings");
  return cookieData ? JSON.parse(cookieData) : [];
};

const saveSharedBooking = (booking: any) => {
  const current = getSharedBookings();
  // De-duplicate by ID
  const filtered = current.filter((b: any) => b.id !== booking.id);
  filtered.unshift(booking);
  // Cap at 15 items to stay under cookie size limit (4KB)
  const trimmed = filtered.slice(0, 15);
  setCookie("shared_bookings", JSON.stringify(trimmed), 30);
};

const getSheetsUrl = () => {
  return (
    process.env.REACT_APP_GOOGLE_SHEETS_URL ||
    getCookie("google_sheets_url") ||
    localStorage.getItem("google_sheets_url") ||
    "https://script.google.com/macros/s/AKfycbwrykp22FTX8JTCpZW_OHHr9gAyzeAIJC8lo4Set5FAaMq4-JjCGntwe-yKly6nZYEO/exec"
  );
};

export const formatPhoneNumber = (phone: any): string => {
  if (!phone) return "";
  let p = String(phone).trim();
  if (p.startsWith("'")) {
    p = p.slice(1);
  }
  if (p.includes("#ERROR")) {
    return p;
  }
  // If it's a standard Egyptian mobile number missing the leading 0 (starts with 10, 11, 12, 15 and is 10 digits)
  if (/^(10|11|12|15)\d{8}$/.test(p)) {
    p = "0" + p;
  }
  // If it is 12 digits starting with 201 (Egypt country code + mobile prefix, e.g. 201097754225)
  else if (/^20(10|11|12|15)\d{8}$/.test(p)) {
    p = "+" + p;
  }
  return p;
};

export const getCachedBookings = () => {
  const shared = getSharedBookings();
  const local = localStorage.getItem("local_bookings");
  const localItems = local ? JSON.parse(local) : [];

  const allBookings: any[] = [];
  const mergeItem = (item: any) => {
    const exists = allBookings.some((ab: any) => String(ab.id) === String(item.id));
    if (!exists) {
      if (item.clientPhone) {
        item.clientPhone = formatPhoneNumber(item.clientPhone);
      }
      allBookings.push(item);
    }
  };

  shared.forEach(mergeItem);
  localItems.forEach(mergeItem);

  allBookings.sort((a: any, b: any) => {
    const dateA = a.createdAt ? new Date(a.createdAt).getTime() : Number(a.id) || 0;
    const dateB = b.createdAt ? new Date(b.createdAt).getTime() : Number(b.id) || 0;
    return dateB - dateA;
  });

  return allBookings;
};

export const getBookings = async () => {
  let firebaseItems: any[] = [];
  let fetchSuccess = true;

  if (db) {
    try {
      const bookingsCol = collection(db, "bookings");
      const q = query(bookingsCol, orderBy("createdAt", "desc"));
      const snapshot = await getDocs(q);
      firebaseItems = snapshot.docs.map(doc => ({
        ...doc.data(),
        id: doc.id
      }));
    } catch (error) {
      console.error("Failed to fetch bookings from Firebase:", error);
      fetchSuccess = false;

      // Fallback query without orderBy in case the index is not ready/built yet
      try {
        const bookingsCol = collection(db, "bookings");
        const snapshot = await getDocs(bookingsCol);
        firebaseItems = snapshot.docs.map(doc => ({
          ...doc.data(),
          id: doc.id
        }));
      } catch (innerError) {
        console.error("Fallback Firebase query failed too:", innerError);
      }
    }
  } else {
    console.warn("Firebase db is not initialized. Using local backup bookings.");
    fetchSuccess = false;
  }

  // Merge Firebase, cookie, and local storage bookings (de-duplicating by ID)
  const shared = getSharedBookings();
  const local = localStorage.getItem("local_bookings");
  const localItems = local ? JSON.parse(local) : [];

  const allBookings = [...firebaseItems];

  // Fallback: If any fetched item has clientPhone === "#ERROR!" or empty, look up in local / shared to find a valid phone
  allBookings.forEach((fb: any) => {
    if (!fb.clientPhone || fb.clientPhone === "#ERROR!") {
      const match = localItems.find((l: any) => String(l.id) === String(fb.id)) ||
                    shared.find((s: any) => String(s.id) === String(fb.id));
      if (match && match.clientPhone && match.clientPhone !== "#ERROR!") {
        fb.clientPhone = match.clientPhone;
      }
    }
    // Fallback for dateTime: if empty in Firebase, restore from local cache
    if (!fb.dateTime) {
      const match = localItems.find((l: any) => String(l.id) === String(fb.id)) ||
                    shared.find((s: any) => String(s.id) === String(fb.id));
      if (match && match.dateTime) {
        fb.dateTime = match.dateTime;
      }
    }
    // Also format the phone number
    if (fb.clientPhone) {
      fb.clientPhone = formatPhoneNumber(fb.clientPhone);
    }
  });

  const mergeItem = (item: any) => {
    const exists = allBookings.some((ab: any) => String(ab.id) === String(item.id));
    if (!exists) {
      if (item.clientPhone) {
        item.clientPhone = formatPhoneNumber(item.clientPhone);
      }
      allBookings.push(item);
    }
  };

  shared.forEach(mergeItem);
  localItems.forEach(mergeItem);

  // Sort descending by ID / Date
  allBookings.sort((a: any, b: any) => {
    const dateA = a.createdAt ? new Date(a.createdAt).getTime() : Number(a.id) || 0;
    const dateB = b.createdAt ? new Date(b.createdAt).getTime() : Number(b.id) || 0;
    return dateB - dateA;
  });

  return { items: allBookings, success: fetchSuccess };
};

export const updateBookingStatus = async (id: any, status: string) => {
  // Update in Firebase if initialized
  if (db) {
    try {
      const bookingRef = doc(db, "bookings", String(id));
      await updateDoc(bookingRef, { status });
    } catch (error) {
      console.error("Failed to update status in Firebase:", error);
    }
  }

  // Update in Google Sheets asynchronously (non-blocking)
  const sheetsUrl = getSheetsUrl();
  const secretToken = process.env.REACT_APP_SHEETS_SECRET_TOKEN || "";
  if (sheetsUrl) {
    fetch(`${sheetsUrl}?action=updateStatus&id=${id}&status=${encodeURIComponent(status)}&secretToken=${encodeURIComponent(secretToken)}`, {
      method: "POST",
      mode: "no-cors"
    }).catch((error) => {
      console.error("Failed to update status in Google Sheets:", error);
    });
  }

  // Update in cookie
  const shared = getSharedBookings();
  const updatedShared = shared.map((b: any) => String(b.id) === String(id) ? { ...b, status } : b);
  setCookie("shared_bookings", JSON.stringify(updatedShared), 30);

  // Update in localStorage
  const local = localStorage.getItem("local_bookings");
  if (local) {
    const bookings = JSON.parse(local);
    const updated = bookings.map((b: any) => String(b.id) === String(id) ? { ...b, status } : b);
    localStorage.setItem("local_bookings", JSON.stringify(updated));
  }

  return { success: true };
};

export const deleteBooking = async (id: any) => {
  // Delete from cookie synchronously
  const shared = getSharedBookings();
  const updatedShared = shared.filter((b: any) => String(b.id) !== String(id));
  setCookie("shared_bookings", JSON.stringify(updatedShared), 30);

  // Delete from localStorage synchronously
  const local = localStorage.getItem("local_bookings");
  if (local) {
    const bookings = JSON.parse(local);
    const updated = bookings.filter((b: any) => String(b.id) !== String(id));
    localStorage.setItem("local_bookings", JSON.stringify(updated));
  }

  // Delete from Firebase asynchronously (non-blocking)
  if (db) {
    const bookingRef = doc(db, "bookings", String(id));
    deleteDoc(bookingRef).catch((error) => {
      console.error("Failed to delete booking in Firebase:", error);
    });
  }

  // Delete from Google Sheets asynchronously (non-blocking)
  const sheetsUrl = getSheetsUrl();
  const secretToken = process.env.REACT_APP_SHEETS_SECRET_TOKEN || "";
  if (sheetsUrl) {
    fetch(`${sheetsUrl}?action=delete&id=${id}&secretToken=${encodeURIComponent(secretToken)}`, {
      method: "POST",
      mode: "no-cors"
    }).catch((error) => {
      console.error("Failed to delete booking in Google Sheets:", error);
    });
  }

  return { success: true };
};

export const createBooking = async (bookingData: any) => {
  const formattedPhone = formatPhoneNumber(bookingData.clientPhone);
  const newBooking = {
    ...bookingData,
    clientPhone: formattedPhone,
    id: String(Date.now()),
    status: "Pending",
    createdAt: new Date().toISOString(),
  };

  // Save to Firebase if initialized (non-blocking in the background to make UI instant)
  if (db) {
    const bookingRef = doc(db, "bookings", newBooking.id);
    setDoc(bookingRef, newBooking)
      .then(() => {
        // Trigger email notification to info@towhelp.co
        try {
          const mailCol = collection(db, "mail");
          addDoc(mailCol, {
            to: "info@towhelp.co",
            message: {
              subject: `حجز جديد من الموقع - رقم ${newBooking.id}`,
              html: `
                <div dir="rtl" style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; border: 1px solid #eee; padding: 20px; border-radius: 10px;">
                  <h2 style="color: #FFAE00; text-align: center; border-bottom: 2px solid #FFAE00; padding-bottom: 10px; margin-top: 0;">حجز جديد - Towhelp</h2>
                  <p style="font-size: 1.1rem; font-weight: bold;">مرحباً إدارة حجوزات موقع Towhelp،</p>
                  <p>تم استلام حجز جديد من الموقع بالتفاصيل التالية:</p>
                  <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
                    <tr>
                      <td style="padding: 10px; border-bottom: 1px solid #eee; font-weight: bold; width: 180px; background-color: #fafafa;">رقم الحجز:</td>
                      <td style="padding: 10px; border-bottom: 1px solid #eee;">${newBooking.id}</td>
                    </tr>
                    <tr>
                      <td style="padding: 10px; border-bottom: 1px solid #eee; font-weight: bold; background-color: #fafafa;">اسم العميل:</td>
                      <td style="padding: 10px; border-bottom: 1px solid #eee;">${newBooking.fullName || "غير محدد"}</td>
                    </tr>
                    <tr>
                      <td style="padding: 10px; border-bottom: 1px solid #eee; font-weight: bold; background-color: #fafafa;">رقم الهاتف:</td>
                      <td style="padding: 10px; border-bottom: 1px solid #eee;"><a href="tel:${newBooking.clientPhone}" style="color: #FFAE00; text-decoration: none; font-weight: bold;">${newBooking.clientPhone}</a></td>
                    </tr>
                    <tr>
                      <td style="padding: 10px; border-bottom: 1px solid #eee; font-weight: bold; background-color: #fafafa;">تاريخ ووقت الحجز:</td>
                      <td style="padding: 10px; border-bottom: 1px solid #eee;">${newBooking.dateTime || "غير محدد"}</td>
                    </tr>
                    <tr>
                      <td style="padding: 10px; border-bottom: 1px solid #eee; font-weight: bold; background-color: #fafafa;">العنوان / الموقع بالتفصيل:</td>
                      <td style="padding: 10px; border-bottom: 1px solid #eee;">${newBooking.location || "غير محدد"}</td>
                    </tr>
                    <tr>
                      <td style="padding: 10px; border-bottom: 1px solid #eee; font-weight: bold; background-color: #fafafa;">نوع الخدمة المطلوبة:</td>
                      <td style="padding: 10px; border-bottom: 1px solid #eee;">${newBooking.serviceName || "غير محدد"}</td>
                    </tr>
                    <tr>
                      <td style="padding: 10px; border-bottom: 1px solid #eee; font-weight: bold; vertical-align: top; background-color: #fafafa;">بيانات السيارة:</td>
                      <td style="padding: 10px; border-bottom: 1px solid #eee;">
                        ${newBooking.cars ? newBooking.cars.map((c: any, index: number) => `
                          <div style="margin-bottom: 10px; border-right: 3px solid #FFAE00; padding-right: 10px; background-color: #fff8eb; padding: 8px; border-radius: 4px;">
                            <strong>السيارة #${index + 1}:</strong><br/>
                            - الماركة: ${c.selectedBrand ? c.selectedBrand.name_ar : c.brandInput || "غير محدد"}<br/>
                            - الموديل: ${c.selectedModel ? c.selectedModel.name_ar : c.modelInput || "غير محدد"}<br/>
                            - اللون: ${c.color || "غير محدد"}<br/>
                            - رقم اللوحة: ${c.plateLetters || ""} ${c.plateNumbers || ""}<br/>
                          </div>
                        `).join("") : "غير محدد"}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 10px; border-bottom: 1px solid #eee; font-weight: bold; vertical-align: top; background-color: #fafafa;">ملاحظات العميل:</td>
                      <td style="padding: 10px; border-bottom: 1px solid #eee;">${newBooking.notes || "لا توجد ملاحظات"}</td>
                    </tr>
                  </table>
                  <br/>
                  <div style="text-align: center; color: #777; font-size: 0.8rem; border-top: 1px solid #eee; padding-top: 15px; margin-top: 15px;">
                    تم إرسال هذا البريد تلقائياً من نظام إدارة حجوزات موقع Towhelp.
                  </div>
                </div>
              `
            }
          }).catch((err) => {
            console.error("Error writing to Firestore mail collection:", err);
          });
        } catch (err) {
          console.error("Failed to trigger mail save:", err);
        }
      })
      .catch((error) => {
        console.error("Failed to post booking to Firebase:", error);
      });
  }

  // Save to Google Sheets if configured (serves as backup and triggers free email notifications)
  const sheetsUrl = getSheetsUrl();
  const secretToken = process.env.REACT_APP_SHEETS_SECRET_TOKEN || "";
  if (sheetsUrl) {
    fetch(sheetsUrl, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...newBooking,
        secretToken
      }),
    }).catch((error) => {
      console.error("Failed to post booking to Google Sheets:", error);
    });
  }

  // Save to shared subdomain cookie
  saveSharedBooking(newBooking);

  // Save to local storage backup
  const local = localStorage.getItem("local_bookings");
  const bookings = local ? JSON.parse(local) : [];
  bookings.unshift(newBooking);
  localStorage.setItem("local_bookings", JSON.stringify(bookings));

  return newBooking;
};